<template>
    <v-container
        class="pt-0 mt-0"
    >
                <!--------------------------------->
                <!--  Set Outer Component Rules  -->
                <!--------------------------------->
        <v-row
            justify="center"
            align="center"
            class="d-flex flex-nowrap"
        >

                <!--------------------------------->
                <!--      Scroll Left Button     -->
                <!--------------------------------->
            <v-btn
                icon
                color="grey darken-4"
                class="ml-3 mr-1"
                @click.prevent="scrollLeft"
            >
                <v-icon
                    large
                >
                    mdi-chevron-left
                </v-icon>
            </v-btn>

                <!--------------------------------->
                <!--      Scrollable Section     -->
                <!--------------------------------->
            <v-container
                id="diet"
                align="center"
                justify="center"
                class="diet"
            >

                <!--------------------------------->
                <!--       Option Iterator       -->
                <!--------------------------------->
                <v-col
                    v-for="(diet,d) in diets"
                    :key="d"
                    flat
                    class="text-no-wrap"
                >
                    <v-card
                        flat
                        width="78"
                        height="95"
                        color="#ffffff"
                    >
                        <v-row
                            justify="center"
                        >
                            <v-avatar
                                v-if="diet.selected | diet.selected == 'true'"
                                size="84"
                                color="#74cf74"
                            >
                                <v-avatar
                                    size="76"
                                >
                                    <img
                                        :src="require('@/assets/diet/' + diet.img)"
                                    />
                                    
                                </v-avatar>
                            </v-avatar>
                            <v-avatar
                                v-else
                                size="66"
                                color="grey darken-4"
                                @click.prevent="updateSelectedDiet(d)"
                            >
                                <v-avatar
                                    size="62"
                                >
                                    <img
                                        :src="require('@/assets/diet/' + diet.img)"
                                    />
                                </v-avatar>
                            </v-avatar>
                        </v-row>
                        <v-row
                            justify="center"
                            class="text-no-wrap"
                        >
                            <div
                                v-if="diet.selected | diet.selected == 'true'"
                                class="ma-0 pa-0 font-weight-black"
                                style="color: #74cf74;"
                            >
                                {{diet.name}}
                            </div>
                            <div
                                v-else
                                class="ma-0 pa-0 font-weight-medium"
                            >
                                {{diet.name}}
                            </div>
                        </v-row>
                        
                    </v-card>
                </v-col>

            </v-container>

                <!--------------------------------->
                <!--     Scroll Right Button     -->
                <!--------------------------------->
            <v-btn
                icon
                color="grey darken-4"
                class="mr-3 ml-1"
                @click.prevent="scrollRight"
            >
                <v-icon
                    large
                >
                    mdi-chevron-right
                </v-icon>
            </v-btn>

        </v-row>
        <v-row
            justify="center"
        >

        </v-row>

    </v-container>
</template>


<style scoped>
    .diet {
        overflow-y: hidden;
        overflow-x: auto;
        display: flex;
        margin: 0px 0px 0px 0px;
        padding: 0px 5px 0px 5px;
    }

    .diet::-webkit-scrollbar {
        display: none;
    }


</style>

<script>
export default {

    data: () => ({
        
    }),
    
    methods: {
        scrollLeft: function() {
            document.getElementById('diet').scrollLeft -= 204
        },
        scrollRight: function() {
            document.getElementById('diet').scrollLeft += 204
        },
        updateSelectedDiet: function(value) {
            this.$store.dispatch('data/updateDiets',value);
            this.$store.dispatch('data/savedPreferences')
        }
    },


    computed: {
        diets() {
            return this.$store.getters['data/diets'];
        },
        account() {
            return this.$store.getters['data/account'];
        },
            
    } 
};
</script>
